import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path id="times-circle-light" d="M175.352,160.332l-6.343,6.343,6.343,6.343a1.1,1.1,0,0,1,0,1.556l-.778.778a1.1,1.1,0,0,1-1.556,0l-6.343-6.343-6.343,6.343a1.1,1.1,0,0,1-1.556,0l-.778-.778a1.1,1.1,0,0,1,0-1.556l6.343-6.343L158,160.332a1.1,1.1,0,0,1,0-1.556l.778-.778a1.1,1.1,0,0,1,1.556,0l6.343,6.343L173.018,158a1.1,1.1,0,0,1,1.556,0l.778.778a1.116,1.116,0,0,1,0,1.556Z" transform="translate(-157.675 -157.676)"/>
    </svg>;
}
